// React
import React, { useRef, useEffect } from "react";
// React
// CSS
import styles from "./QuestionReports.module.css";
import "./reports.css";
// CSS

import parse from "html-react-parser";
import { useLocation, useNavigate } from "react-router-dom";

type QuestionReportsProps = {
  data: string[];
  setIsReportInScreen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedAnswers: {
    qId: string;
    aId: string;
  }[];
};

const QuestionReports: React.FunctionComponent<QuestionReportsProps> = ({
  data,
  setIsReportInScreen,
  selectedAnswers,
}) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const outerRef = useRef<HTMLDivElement>(null);

  const { state } = useLocation();
  const navigate = useNavigate();
  const closeModal = () => {
    if (!innerRef.current) return;
    if (!outerRef.current) return;

    innerRef.current.style.top = "90vh";
    outerRef.current.style.opacity = "0";

    setTimeout(() => {
      setIsReportInScreen(false);
    }, 500);
  };

  useEffect(() => {
    setTimeout(() => {
      if (!innerRef.current) return;
      if (!outerRef.current) return;

      innerRef.current.style.top = "0";
      outerRef.current.style.opacity = "0.7";
    }, 50);
  }, []);
  return (
    <div
      className={`${
        styles.questionReportsContainer
      } w-screen h-screen fixed top-0 ${
        window.innerWidth > 600 ? "left-auto" : "left-0"
      } flex items-center justify-center z-30`}
    >
      <div
        className={`${styles.outer} fixed w-full h-full top-0 ${
          window.innerWidth > 600 ? "left-auto" : "left-0"
        } bg-black z-40`}
        ref={outerRef}
        onClick={closeModal}
      ></div>
      <div
        className={`${styles.content} mx-4 p-4 bg-white z-50 w-full rounded-lg`}
        ref={innerRef}
      >
        <div className="w-full flex flex-row-reverse items-center  ">
          <p className="block w-1/2 text-right">نــام درس</p>
          <p className="w-1/2 flex flex-row-reverse items-center justify-between">
            <span className="block text-center" style={{ color: "purple" }}>
              درصد
            </span>
            <span className="block text-center" style={{ color: "green" }}>
              صحیح
            </span>
            <span className="block text-center" style={{ color: "red" }}>
              اشتباه
            </span>

            <span className="block text-center">کل</span>
          </p>
        </div>
        <div className={`${styles.items}`}>
          {data.map((item) => (
            <div key={item} className={`${styles.item}`}>
              {parse(
                item.replace(/تعداد صحیح:/g, "").replace(/تعداد اشتباه:/g, "")
              )}
            </div>
          ))}
        </div>

        <div
          className={`${styles.buttonsContainer} w-full flex flex-row-reverse items-center justify-between mt-6`}
        >
          <button
            style={{ background: `rgb(244,67,54)`, width: `48%` }}
            className="py-2 rounded-lg text-white "
            onClick={() => {
              navigate("/profile/pdf-maker", {
                state: {
                  currMode: state.currMode,
                  quizId: state.quizId,
                },
              });
            }}
          >
            {" "}
            PDF درخواست
          </button>
          <button
            style={{ background: `rgb(126,58,229)`, width: `48%` }}
            className="py-2 rounded-lg text-white "
            onClick={() => {
              navigate("/quiz-maker/show-answers", {
                state: {
                  selectedAnswers: selectedAnswers.map((item) => item.aId),
                  currMode: state.currMode,
                  quizId: state.quizId,
                },
              });
            }}
          >
            نمــایش پاسخنامه
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionReports;
